import axios from 'axios';
import { API_BASE_URI } from './config';
import { dateReviver } from './utilities/json-reviver';

/**
 * Axios instance with pre-configured defaults
 */
const api = axios.create({
    baseURL: API_BASE_URI,
});

api.interceptors.response.use(
    (response) => {
        // if (typeof response.data === 'object') {
        //     const data = JSON.parse(response.request?.response, dateReviver);

        //     response.data = data;
        // }
        // return response;

        return response;
    },
    (error) => {
        if (error.response.status === 503) {
            location.href = '/maintenance';
        } else {
            return Promise.reject(error);
        }
    }
);

let existingInterceptor: number;

/**
 * Adds an interceptor to every request, ensuring an access token is included.
 * @param interceptor The function to call before each request to obtain an access token.
 *
 * NOTE: the provided function must return a string (access token)
 */
function addAuthInterceptor(interceptor: () => Promise<string>): void {
    if (existingInterceptor) {
        api.interceptors.request.eject(existingInterceptor);
    }

    existingInterceptor = api.interceptors.request.use(
        async function (config) {
            const token = await interceptor();

            if (!config.headers) {
                config.headers = {};
            }
            config.headers.Authorization = 'Bearer ' + token;

            return config;
        },
        (error) => Promise.reject(error)
    );
}

function addFirmHeader(value: string): void {
    api.defaults.headers.common['X-Firm-Id'] = value;
}

export { api, addAuthInterceptor, addFirmHeader };
